//Files Taxes:
export const UNKNOWN = "unknown";
export const YES = "yes";
export const NO = "no";

//Gender:
export const FEMALE = "female";
export const MALE = "male";
